import { render, staticRenderFns } from "./HeaderUser.vue?vue&type=template&id=e4b546e4"
import script from "./HeaderUser.vue?vue&type=script&lang=js"
export * from "./HeaderUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports